import React, { Component } from "react";
import ReactDOM from "react-dom";

export default class Base extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	renderContent(loading) {
		if (loading) {
			return this.renderLoad();
		}

		return this.renderAfterLoad();
	}

	renderLoad() {
		return null;
	}

	renderAfterLoad() {
		return null;
	}
}
